import { useQuery } from 'hooks/useCustomQuery';
import { useSelector, useDispatch } from 'react-redux';
import getAllTrunks from 'API/Trunk/getAllTrunks';

const useGetAllTrunks = (setTableData) => {
    const dispatch = useDispatch();
    const { currentCompany, currentPartner, currentWholesaler } = useSelector(
        (state) => state.navigationLists,
    );
    const { requiredScope } = useSelector((state) => state.login);

    return useQuery({
        queryKey: ['trunks', requiredScope, ],
        queryFn: async () => {
            return getAllTrunks(currentCompany, requiredScope);
        },
        enabled: !!currentCompany, // Only run query when we have a company
        onSuccess: (data) => {
            const sortedData = (data || []).sort((a, b) => {
                const nameA = a.name?.toLowerCase() || '';
                const nameB = b.name?.toLowerCase() || '';
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
            });

            if (setTableData) {
                setTableData((prev) => ({
                    ...prev,
                    data: sortedData,
                }));
            }

            // Dispatch to update table loading state
            dispatch({
                type: 'CHANGE_TABLE_LOADING',
            });
        },
        onError: (error) => {
            console.error('Error fetching trunks:', error);
            if (setTableData) {
                setTableData((prev) => ({
                    ...prev,
                    data: [],
                }));
            }
        },
        staleTime: 0,
    });
};

export default useGetAllTrunks;
